<div [ngClass]="customClass" [style.width]="width" class="cab-input">
  @if (label.length > 1) {
    <app-cab-label [for]="id" [label]="label" [required]="required" />
  }

  <div class="d-flex align-items-center position-relative">
    <ng-content select="#cab-input-before" />
    <input
      [dropSpecialCharacters]="dropSpecialCharacters"
      [formControl]="formControl"
      [mask]="mask"
      [step]="step"
      [patterns]="patterns"
      [type]="type"
      [allowNegativeNumbers]="allowNegativeNumbers"
      [id]="id"
      [max]="max"
      [min]="min"
      (input)="onInput.emit(formControl.value)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      [placeholder]="placeholder | translate"
      [prefix]="prefix"
      [suffix]="suffix"
      [readonly]="readonly"
      [decimalMarker]="decimalMarker"
      [showMaskTyped]="showMaskTyped"
      [attr.autocomplete]="autocomplete"
      class="cab-input-field form-control form-control-{{ size }} w-100"
    />
  </div>

  @if (showValidationErrors()) {
    <div [innerHTML]="errorMessagesHtml()" class="text-danger text-start"></div>
  }
</div>
